import makeApiRequest from './makeApiCall';

export const requestLogin = async (data) => {
  return await makeApiRequest(`/users/login`, 'POST', '', data);
};

export const crossLogin = async (euid, token) => {
  return await makeApiRequest(`/signin`, 'GET', '', {
    euid,
    token,
  });
};

export const getEcosystemDetails = async (euid) => {
  return await makeApiRequest('/ecosystem_detail/' + euid, 'GET');
};

export const requestVerifyOTP = async (data) => {
  return await makeApiRequest(`/verify-otp`, 'POST', '', data);
};

export const requestResendOTP = async (data) => {
  return await makeApiRequest(`/resend-otp`, 'POST', '', data);
};

export const requestGetUserOtpVia = async (data) => {
  return await makeApiRequest(`/get-user-otp-via`, 'POST', '', data);
};
